/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Title1Inputs */

const zh_organizationsettings_title1 = /** @type {(inputs: Organizationsettings_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`组织与团队`)
};

const en_organizationsettings_title1 = /** @type {(inputs: Organizationsettings_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization & Teams`)
};

const es_organizationsettings_title1 = /** @type {(inputs: Organizationsettings_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organización y equipos`)
};

/**
* | output |
* | --- |
* | "Organization & Teams" |
*
* @param {Organizationsettings_Title1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_title1 = /** @type {((inputs?: Organizationsettings_Title1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Title1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_title1(inputs)
	if (locale === "en") return en_organizationsettings_title1(inputs)
	return es_organizationsettings_title1(inputs)
});
export { organizationsettings_title1 as "organizationSettings_title" }